import { enrichImageObject, getPublicFirestoreUrl } from './encoding-helpers';

const DEFAULT_COLOR_PRIMARY = '#868E96';
const DEFAULT_COLOR_SECONDARY = '#E4B21A';
const DEFAULT_TEXT_COLOR_PRIMARY = '#212529';
const DEFAULT_TEXT_COLOR_SECONDARY = '#212529';
const TEXT_COLORS = {
  white: '#ffffff',
  black: '#212529',
};

import {
  projectVisibilityMap, projectActivationStatusMap, projectStatusMap,
} from '../models/project-client-enums.js';


export const enrichProject = (project) => {
  if (!project || project.isEnriched) return project;

  const visibilitySettings = projectVisibilityMap[project.visibility] || {};
  const statusSettings = projectStatusMap[project.status] || {};
  const activationStatusSettings = projectActivationStatusMap[project.activationStatus] || {};

  Object.assign(project, {
    isEnriched: true,

    detailViewPath: `/projects/${project.key}`,
    ref: `projects/${project.id}`,
    
    avatar_icon: 'business_center',
    avatar_shape: 'rounded',
    avatar: enrichImageObject(project.avatar),

    colorPrimary: project.colorPrimary || DEFAULT_COLOR_PRIMARY,
    colorSecondary: project.colorSecondary || DEFAULT_COLOR_SECONDARY,
    
    textColorPrimary_hex: TEXT_COLORS[project.textColorPrimary] || DEFAULT_TEXT_COLOR_PRIMARY,
    textColorSecondary_hex: TEXT_COLORS[project.textColorSecondary] || DEFAULT_TEXT_COLOR_SECONDARY,
    textColorPrimary_isWhite: project.textColorPrimary === 'white',
    textColorSecondary_isWhite: project.textColorSecondary === 'white',

    visibility_label: visibilitySettings?.label || 'Unknown',
    visibility_description: visibilitySettings?.description || '',
    visibility_icon: visibilitySettings?.icon || 'help',

    status_label: statusSettings?.label || 'Unknown',
    status_description: statusSettings?.description || '',
    status_icon: statusSettings?.icon || 'help',
    status_iconLibrary: statusSettings?.iconLibrary || 'material',
    status_tagVariant: statusSettings?.tagVariant || 'default',

    activationStatus_label: activationStatusSettings?.label || 'Unknown',
    activationStatus_description: activationStatusSettings?.description || '',
    activationStatus_organizerNotes: activationStatusSettings?.organizerNotes || '',
    activationStatus_icon: activationStatusSettings?.icon || 'help',
    activationStatus_iconLibrary: activationStatusSettings?.iconLibrary || 'material',
    activationStatus_tagVariant: activationStatusSettings?.tagVariant || 'default',
  });

  return project;
}

/**
 * This is a somewhat lightweight enrichProject, intended for enriching items from a project search
 * cache. It assumes that the `profile` field is a flat string of a firebase storage key already.
 * 
 * It returns the original object with the following additions:
 * - ref: A firestore reference string for the project (ex: `projects/0KMscGXbeK4hMvlnt0UZ`)
 * - url: The relative URL to the projects's page (ex: `/projects/:key`)
 * - profile: The fully qualified URL to the projects's profile image. This overwrites the prior
 *   value of `profile` in the original object and assumes that the original value is a firebase
 *   storage key (not an object).
 */
export const enrichProjectSearchItem = (project) => {
  if (project.isEnriched) return project;

  Object.assign(project, {
    ...project,

    isEnriched: true,

    ref: `projects/${project.id}`,
    url: `/projects/${project.key}`,
    profile: getPublicFirestoreUrl(project.profile),
  });

  return project;
}